import React, { createContext, useContext } from 'react';

import { useSafeAreaInsets } from 'react-native-safe-area-context';
import type { EdgeInsets } from 'react-native-safe-area-context';

const ZERO_INSETS: EdgeInsets = { top: 0, right: 0, bottom: 0, left: 0 };
const RootSafeAreaInsetsContext = createContext<EdgeInsets>(ZERO_INSETS);

/**
 * Preserves the root window insets across navigators that install their own SafeAreaProvider.
 * NativeTabs does this per screen on iOS, while manually rendered tab headers are positioned
 * relative to the window's safe area.
 */
export const RootSafeAreaInsetsProvider = ({ children }: React.PropsWithChildren) => {
  const insets = useSafeAreaInsets();

  return (
    <RootSafeAreaInsetsContext.Provider value={insets}>
      {children}
    </RootSafeAreaInsetsContext.Provider>
  );
};

export const useRootSafeAreaInsets = () => useContext(RootSafeAreaInsetsContext);

export const resolveNativeTabsHeaderTopInset = ({
  localTop,
  rootTop,
  useNativeTabsRootInset,
}: {
  localTop: number;
  rootTop: number;
  useNativeTabsRootInset: boolean;
}) => (useNativeTabsRootInset ? rootTop : localTop);
